// extracted by mini-css-extract-plugin
export default {"categoryListContainer":"_3UlJS","title":"_1qurO"};